import uuidv4 from "uuid/v4";
import { getStatusColor } from "@wrstudios/theme";
import { transformListing } from "./listing";

export function transformForgePin(pin) {
  const listings = pin.records || [];
  const isCluster = listings.length > 1;
  return {
    isCluster,
    markerId: uuidv4(),
    lat: Number(pin.lat),
    lon: Number(pin.lon),
    listings: listings.map(transformForgeListing)
  };
}

export function transformForgeListing(listing) {
  const transformedListing = transformListing(listing);
  return {
    ...transformedListing,
    statusColor: getStatusColor(transformedListing.mappedStatus),
    isHidden: true,
    isForgeListing: true
  };
}
